<template>
	<div class="accordion">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'Accordion',
	mounted() {
		const children = this.$children.filter(vm => {
			return vm.$options._componentTag === 'AccordionItem'
		})
		const items = children.length
		for (let i = 0; i < items; i++) {
			// Partition children
			const child = children[i]
			const others = children.filter((_, j) => j !== i)

			// Add listeners
			child.$on('open', open => {
				child.open = open
				if (open) others.forEach(other => (other.open = false))
			})
		}
	}
}
</script>

<style lang="scss" scoped></style>
